import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ILinksModalPayload } from '../../models/links-modal-payload';

@Component({
  selector: 'epc-order-row-links-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './links-modal.component.html',
  styleUrls: ['./links-modal.component.scss'],
  imports: [ModalModule],
})
export class OrderRowLinksModalComponent {
  @Input()
  public title?: string;

  @Input()
  public links: ILinksModalPayload[] = [];

  constructor(private modal: NgbActiveModal) {}

  public close() {
    this.modal.close();
  }
}
